"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const errors_1 = require("@/common/errors");
const _1 = require(".");
function default_1({ errorResult, setPaymentDetail, confirm, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { error_msg } = errorResult;
        const errorConfirm = (description) => (0, errors_1.alertConfirm)({ confirm, description });
        const updatePaymentDetail = () => __awaiter(this, void 0, void 0, function* () { return yield (0, _1.refetchPaymentDetail)({ setPaymentDetail }); });
        const settingRequiredConfirm = (description) => {
            confirm({
                description,
                confirmationText: i18next_1.default.t('인증하기'),
            })
                .then(() => (window.location.href = '/member/setting'))
                .catch(() => { });
        };
        switch (error_msg) {
            case 'PAYMENT_EXPIRED_ORDER_ERROR': // ? 자동구매 취소 예정
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('결제 마감으로 곧 구매 취소돼요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('취소된 작품은 다시 구매할 수 있어요!')] }));
                yield updatePaymentDetail();
                break;
            case 'ALREADY_AUTO_CANCELLED_ORDER_ERROR': // ? 자동구매 취소됨
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('결제 마감으로 구매 취소 됐어요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('취소된 작품은 다시 구매할 수 있어요!')] }));
                yield updatePaymentDetail();
                break;
            case 'ROOM_DELETED_ORDER_ERROR': // ? 판매자가 무산or취소한 폼
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('판매 무산된 작품이에요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('작가님께 문의해 주세요')} :)`] }));
                yield updatePaymentDetail();
                break;
            case 'BLOCKED_ERROR': // ? 판매자가 구매자를 차단함
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님 차단으로 결제할 수 없어요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('해제는 작가님께 문의해주세요!')] }));
                yield updatePaymentDetail();
                break;
            case 'VBANK_ISSUED_ORDER_ERROR': // ? (1차결제) 가상계좌가 이미 발급됨
                errorConfirm(i18next_1.default.t('이미 계좌 발급되었어요'));
                yield updatePaymentDetail();
                break;
            case 'ALREADY_ORDERED_ORDER_ERROR': // ? 이미 1차결제됨
            case 'ALREADY_ORDERED_SECOND_ORDER_ERROR': // ? 이미 2차결제됨
                errorConfirm(i18next_1.default.t('이미 결제된 주문이에요'));
                yield updatePaymentDetail();
                break;
            case 'NOT_ORDERED_ORDER_ERROR': // ! (2차결제) 1차결제가 안되어 있음
                errorConfirm(`${i18next_1.default.t('먼저 [ 결제하기 ] 완료 후 2차 결제 진행해 주세요')} :)`);
                yield updatePaymentDetail();
                break;
            case 'BUYER_CERTIFICATION_ERROR':
                settingRequiredConfirm(i18next_1.default.t('작가님 요청으로 본인인증이 필요해요'));
                break;
            case 'BUYER_PARENTAL_CONSENT_CERTIFICATION_ERROR':
                settingRequiredConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님 요청으로'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('본인인증 및 법정대리인 동의가 필요해요')] }));
                break;
            case 'BUYER_ADULT_ONLY_CERTIFICATION_ERROR':
                settingRequiredConfirm(i18next_1.default.t('작가님 요청으로 19세 성인인증이 필요해요'));
                break;
            case 'BUYER_UNDER_14_CERTIFICATION_ERROR':
                settingRequiredConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님 요청으로 만 14세 이상만'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('구매할 수 있어요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('만 나이는 생일이 지나야 해요')}:)`] }));
                break;
            case 'ALREADY_STORE_DONE_ROOM_ERROR': // ? 폼이 이미 폐기됨
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('현재는 2차 결제를 이용할 수 없어요!'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('작가님께 문의해 주세요')} :)`] }));
                yield updatePaymentDetail();
                break;
            case 'SECOND_PAYMENT_REQUEST_CANCELLED_STATUS_ERROR':
            case 'SECOND_PAYMENT_REQUEST_REFUND_STATUS_ERROR':
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님 요청으로 2차 결제 요청 취소되었어요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('작가님께 문의해 주세요')} :)`, (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('결제하셨다면 지갑 잔액을 확인해 주세요!')] }));
                yield updatePaymentDetail();
                break;
            case 'SECOND_PAYMENT_REQUEST_PERIOD_ERROR':
                errorConfirm(i18next_1.default.t('결제마감되어 2차 결제할 수 없어요!'));
                break;
            default:
                (0, errors_1.commonErrorConfirm)({ confirm, errorReason: '0' });
        }
    });
}
exports.default = default_1;
